import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, withDirectives as _withDirectives, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-21157d28"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "m-2" };
const _hoisted_2 = { class: "flex flex-row gap-2" };
const _hoisted_3 = { class: "tag-link-url mr-1" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "flex flex-row gap-2" };
const _hoisted_6 = {
    class: "flex justify-content-end",
    style: { "width": "100%" }
};
import Tag from "primevue/tag";
import OneDeskButton from "@/components/atoms/OneDeskButton.vue";
import { LinkType } from "@/entities/card.entity";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CatalogCardLinksDisplay',
    props: {
        links: {},
        linkType: { default: LinkType.Required }
    },
    emits: ["add-new-link", "edit-link", "delete-link"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const addNewLink = () => emit("add-new-link", props.linkType);
        const editLink = (id) => emit("edit-link", { id, linkType: props.linkType });
        const deleteLink = (id) => emit("delete-link", id);
        const openLink = (url) => window.open(url, "_blank");
        return (_ctx, _cache) => {
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "flex flex-row align-items-center justify-content-between gap-1 my-2",
                        key: index
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            (link.label)
                                ? (_openBlock(), _createBlock(_unref(Tag), {
                                    key: 0,
                                    icon: "pi pi-tag",
                                    value: link.label,
                                    severity: "info"
                                }, null, 8, ["value"]))
                                : _createCommentVNode("", true),
                            (link.value)
                                ? _withDirectives((_openBlock(), _createBlock(_unref(Tag), {
                                    key: 1,
                                    icon: "pi pi-globe",
                                    severity: "secondary"
                                }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_3, _toDisplayString(link.value), 1),
                                        _createElementVNode("i", {
                                            class: "pi pi-external-link",
                                            style: { "cursor": "pointer" },
                                            onClick: ($event) => (openLink(link.value))
                                        }, null, 8, _hoisted_4)
                                    ]),
                                    _: 2
                                }, 1024)), [
                                    [
                                        _directive_tooltip,
                                        link.value,
                                        void 0,
                                        { top: true }
                                    ]
                                ])
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(OneDeskButton, {
                                severity: "success",
                                icon: "pi pi-pencil",
                                onClick: ($event) => (editLink(link.id)),
                                outlined: true
                            }, null, 8, ["onClick"]),
                            _createVNode(OneDeskButton, {
                                severity: "warning",
                                icon: "pi pi-trash",
                                outlined: true,
                                acceptCallback: () => deleteLink(link.id),
                                rejectCallback: () => { },
                                "confirm-group": link.id
                            }, null, 8, ["acceptCallback", "confirm-group"])
                        ])
                    ]));
                }), 128)),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(OneDeskButton, {
                        severity: "primary",
                        icon: "pi pi-plus",
                        onClick: addNewLink,
                        outlined: true
                    })
                ])
            ]));
        };
    }
});
